import { render, staticRenderFns } from "./insertion-order-list.vue?vue&type=template&id=4f519416"
import script from "./insertion-order-list.vue?vue&type=script&lang=js"
export * from "./insertion-order-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports